"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingState = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const contexts_1 = require("../../contexts");
const getComponent_1 = require("../../getComponent");
const ActivityIndicator = getComponent_1.getComponent('ActivityIndicator');
const ComponentState = getComponent_1.getComponent('ComponentState');
/**
 * # ⏳ LoadingState
 *
 * A component that is used to show a loading state. Shows a spinner by
 * default. If 'timedOut' flag is set then it shows a timeout version.
 *
 * ## Usage
 * ```jsx
 * <LoadingState timedOut={false} retry={retryFunction}/>
 * ```
 *
 * TODO: Add a prop to allow custom text for retry button.
 */
class LoadingState extends react_1.default.Component {
    render() {
        const { timedOut, retry } = this.props;
        const props = {
            image: react_1.default.createElement(ActivityIndicator, null),
        };
        if (timedOut === true) {
            props.description = 'This is taking longer than usual';
            if (retry) {
                props.actionTitle = 'Retry';
                props.actionOnPress = retry;
            }
        }
        return react_1.default.createElement(ComponentState, Object.assign({}, props));
    }
}
exports.LoadingState = LoadingState;
LoadingState.contextType = contexts_1.BlueBaseContext;
